import React from 'react';
import { CalendarCheckIcon, MailIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import type { Channel } from '../../types/activity';
interface ChannelBadgeProps {
  channel: Channel;
  size?: 'sm' | 'md';
  muted?: boolean;
}
const CONFIG: Record<Channel, {
  Icon: typeof PhoneIcon;
  fill: string;
  tint: string;
}> = {
  call: {
    Icon: PhoneIcon,
    fill: 'text-channel-call',
    tint: 'bg-channel-call-soft'
  },
  sms: {
    Icon: MessageSquareIcon,
    fill: 'text-channel-sms',
    tint: 'bg-channel-sms-soft'
  },
  email: {
    Icon: MailIcon,
    fill: 'text-channel-email',
    tint: 'bg-channel-email-soft'
  },
  event: {
    Icon: CalendarCheckIcon,
    fill: 'text-channel-event',
    tint: 'bg-channel-event-soft'
  }
};
export function ChannelBadge({
  channel,
  size = 'md',
  muted = false
}: ChannelBadgeProps) {
  const {
    Icon,
    fill,
    tint
  } = CONFIG[channel];
  const box = size === 'sm' ? 'h-5 w-5' : 'h-7 w-7';
  const glyph = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded-md ${box} ${muted ? 'bg-surface-muted ring-1 ring-line' : tint}`} data-id="element-48" data-mp="2c2p9kfgyknw6">
      <Icon className={`${glyph} ${muted ? 'text-ink-subtle' : fill}`} data-id="element-49" data-mp="2l07yhuxq3mdc" />
    </span>;
}